import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (!user) return null;

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <Link to="/dashboard" className="navbar-brand">
          <span className="navbar-logo"><img src="/image/logo.png" alt="Eventoz Logo" /></span>
          Eventoz.app
        </Link>

        <div className="navbar-menu">
          <Link to="/dashboard" className="navbar-link">Eventos</Link>
          {!user.isCollaborator && (
            <Link to="/whatsapp" className="navbar-link">WhatsApp</Link>
          )}
          
          <div className="navbar-user">
            <span className="navbar-user-name">{user.name}</span>
            <button onClick={handleLogout} className="btn btn-sm btn-outline">
              Sair
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
